import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import { Lock } from 'lucide-react';
import toast from 'react-hot-toast';

export default function ResetarSenhaPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return setErro('Senha deve ter no mínimo 6 caracteres');
    if (password !== confirm) return setErro('As senhas não coincidem');
    setLoading(true);
    setErro('');
    try {
      await api.post(`/auth/resetar-senha/${token}`, { password });
      toast.success('Senha redefinida com sucesso!');
      navigate('/login');
    } catch (err) {
      setErro(err.response?.data?.error || 'Link inválido ou expirado.');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 max-w-md w-full">
        <h1 className="text-xl font-bold text-gray-900 mb-1">Nova senha</h1>
        <p className="text-sm text-gray-400 mb-6">Escolha uma senha segura para sua conta.</p>
        <form onSubmit={handleSubmit} className="space-y-4">
          {[
            { label: 'Nova senha', value: password, set: setPassword, placeholder: 'Mínimo 6 caracteres' },
            { label: 'Confirmar senha', value: confirm, set: setConfirm, placeholder: 'Repita a senha' },
          ].map(({ label, value, set, placeholder }) => (
            <div key={label}>
              <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input type="password" value={value} onChange={e => set(e.target.value)} placeholder={placeholder}
                  className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 outline-none" />
              </div>
            </div>
          ))}
          {erro && <p className="text-sm text-red-500">{erro}</p>}
          <button type="submit" disabled={loading}
            className="w-full py-2.5 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 text-white rounded-xl text-sm font-medium transition-colors">
            {loading ? 'Salvando...' : 'Redefinir senha'}
          </button>
        </form>
        <p className="text-center mt-4 text-sm text-gray-500">
          <Link to="/login" className="text-blue-600 hover:underline">Voltar ao login</Link>
        </p>
      </div>
    </div>
  );
}